export default __webpack_public_path__ + "static/media/plan_product_default_cover.76dda9f4.jpg";